"use client";

import { HeadSpaIntroSection } from "./sections/HeadSpaIntroSection";
import { HeadSpaQuEstCeQueSection } from "./sections/HeadSpaQuEstCeQueSection";
import { HeadSpaVisionSection } from "./sections/HeadSpaVisionSection";
import { HeadSpaFeaturedServiceSection } from "./sections/HeadSpaFeaturedServiceSection";
import { HeadSpaInfosSection } from "./sections/HeadSpaInfosSection";
import { HeadSpaDiagnosticSection } from "./sections/HeadSpaDiagnosticSection";
import { HeadSpaSoinsSection } from "./sections/HeadSpaSoinsSection";
import { HeadSpaReviewsWidget } from "./components/HeadSpaReviewsWidget";
import { MetaPixel } from "./components/MetaPixel";
import { FindUsSection } from "@/components/sections/find-us/FindUsSection";
import { ReviewsSection } from "@/components/sections/reviews/ReviewsSection";
import { OurSalonsHours } from "@/components/sections/nos-salons-hours/OurSalonsHours";
import { SeoSection } from "@/components/sections/SeoSection";
import { RelatedArticles } from "@/components/sections/RelatedArticles";
import { blogPosts } from "../blog/data/blog/blog";
import { headSpaData } from "./data/head-spa-data";

export default function HeadSpaPage() {
  return (
    <>
      <MetaPixel />
      <HeadSpaIntroSection
        aboveTitle={headSpaData.introSection.aboveTitle}
        title={headSpaData.introSection.title}
        subtitle={headSpaData.introSection.subtitle}
        content={headSpaData.introSection.content}
      />

      <HeadSpaFeaturedServiceSection />


      <HeadSpaQuEstCeQueSection
        label={headSpaData.quEstCeQueSection.label}
        title={headSpaData.quEstCeQueSection.title}
        description={headSpaData.quEstCeQueSection.description}
        benefits={headSpaData.quEstCeQueSection.benefits}
      />


      <HeadSpaVisionSection
        label={headSpaData.visionSection.label}
        title={headSpaData.visionSection.title}
        paragraphs={headSpaData.visionSection.paragraphs}
      />



      {process.env.NODE_ENV === "production" ? (
        <HeadSpaReviewsWidget />
      ) : (
        <ReviewsSection />
      )}


    </>
  );
}
